import { Badge } from "@fronterahealth/frontera-ui-components";

import { VerificationStatusEnum } from "@api/rest/types-and-hooks";

export const renderVerificationStatus = (status: VerificationStatusEnum) => {
  if (status === VerificationStatusEnum.VERIFIED) return <Badge appearance="success" text="Verified" />;
  if (status === VerificationStatusEnum.PENDING) return <Badge appearance="warn" text="Pending" />;
  return <Badge appearance="neutral" text="Unverified" />;
};
